import { render, staticRenderFns } from "./goods_lover.vue?vue&type=template&id=623e7516&scoped=true"
import script from "./goods_lover.vue?vue&type=script&lang=js"
export * from "./goods_lover.vue?vue&type=script&lang=js"
import style0 from "./goods_lover.vue?vue&type=style&index=0&id=623e7516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e7516",
  null
  
)

export default component.exports